import React, { useState } from 'react';
import { FacebookIcon, Instagram, Loader2 } from 'lucide-react';
import InstagramPreview from './InstagramPreview';
import FacebookPreview from './FacebookPreview';
import RegeneratePostForm from './RegeneratePostForm';
import SchedulePost from './SchedulePost';
import Tabs from '../ui/Tabs';

const PostModalContent = ({
  post,
  isLoading,
  onRegenerateSubmit,
  showProductImage = false,
  socialAccounts = [],
  onScheduleSubmit,
  onEditSubmit,
}) => {
  const [previewPlatform, setPreviewPlatform] = useState('instagram');

  return (
    <div className='flex-1 grid grid-cols-1 lg:grid-cols-2 min-h-0'>
      {/* Preview Section */}
      <div className='bg-gray-50 flex flex-col min-h-0'>
        <div className='flex-shrink-0 pt-4'>
          {/* Platform Selector */}
          <div className='flex justify-center gap-4'>
            <button
              onClick={() => setPreviewPlatform('instagram')}
              className={`p-2 rounded-full text-sm font-medium transition-colors ${
                previewPlatform === 'instagram'
                  ? 'bg-gradient-to-r from-purple-500 to-pink-500 text-white'
                  : 'bg-white text-gray-700 border border-gray-300 hover:bg-gray-50'
              }`}
            >
              <Instagram />
            </button>
            <button
              onClick={() => setPreviewPlatform('facebook')}
              className={`p-2 rounded-full text-sm font-medium transition-colors ${
                previewPlatform === 'facebook'
                  ? 'bg-blue-700 text-white'
                  : 'bg-white text-gray-700 border border-gray-300 hover:bg-gray-50'
              }`}
            >
              <FacebookIcon />
            </button>
          </div>
        </div>

        {/* Preview Area */}
        <div className='flex-1 flex items-center justify-center p-4 lg:pb-10 min-h-0 relative'>
          <div className='relative w-full h-full flex items-center justify-center'>
            {previewPlatform === 'instagram' ? (
              <InstagramPreview
                post={post}
                layout={post?.aspectRatio === '9:16' ? 'story' : 'feed'}
              />
            ) : (
              <FacebookPreview
                post={post}
                layout={post?.aspectRatio === '9:16' ? 'story' : 'feed'}
              />
            )}

            {/* Loading Overlay */}
            {isLoading && (
              <div className='absolute inset-0 bg-transparent flex w-full items-center justify-center backdrop-blur-sm z-50'>
                <div className='bg-transparent  rounded-lg p-2 flex items-center gap-3'>
                  <Loader2 className='w-10 h-10 text-blue-600 animate-spin' />
                  <span className='text-base font-semibold text-white'>Regenerating...</span>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Right Section - Actions and Details */}
      <div
        className={`bg-white border-t lg:border-t-0 lg:border-l p-4 md:p-6 min-h-0 max-h-[190vh] relative ${
          isLoading ? 'pointer-events-none opacity-50' : ''
        }`}
      >
        <Tabs
          tabs={[
            { id: 'regenerate', title: 'Regenerate' },
            { id: 'details', title: 'Details' },
          ]}
          className='h-[400px] lg:h-screen lg:px-inherit'
        >
          <RegeneratePostForm
            post={post}
            onRegenerateSubmit={onRegenerateSubmit}
            showProductImage={showProductImage}
            tabId='regenerate'
          />

          <SchedulePost
            post={post}
            socialAccounts={socialAccounts}
            onScheduleSubmit={onScheduleSubmit}
            onEditSubmit={onEditSubmit}
            tabId='details'
          />
        </Tabs>
      </div>
    </div>
  );
};

export default PostModalContent;
